import { useQueryClient } from '@tanstack/react-query'
import { Logger, type ImportData, type ImportId } from '@terros/common'

const logger = new Logger('useImportCache')

export function useImportCache() {
  const queryClient = useQueryClient()
  const clearList = (): void => {
    logger.verbose('invalidateQueries imports')
    queryClient.invalidateQueries({ queryKey: ['imports'] })
  }
  return {
    clearList,
    addItem: (item: ImportData) => {
      logger.verbose('addItem import', item)
      clearList()
    },
    replaceItem: (item: ImportData) => {
      logger.verbose('replaceItem import', item)
      clearList()
    },
    removeItem: (importId: ImportId) => {
      logger.verbose('removeItem importId', importId)
      clearList()
    },
  }
}
